export const copyToClipboard = function (el,evt) {
    evt.preventDefault();
    const text = el.getAttribute("data-clipboard-text");
    const inputc = document.body.appendChild(document.createElement("input"));
    inputc.value = text;
    inputc.focus();
    inputc.select();
    document.execCommand("copy");
    inputc.parentNode.removeChild(inputc);
};
